<script>import Select from "svelte-select";
export let options = [];
export let value;
export let clearable;
export let className;
export let placeholder = "please select";
export let handleOnchange = () => {
};
export let disabled = false;
function handle(e) {
  console.log(e.detail), "Fsdfsdfsdfsdfsd";
}
</script>

<Select
	items={options}
	placeholder={placeholder}
	class={`width-class form-select z-50 appearance-none !rounded-full !border !border-solid !border-border decoration-secondary focus:outline-none ${className}`}
	bind:value={value}
	showChevron={true}
	on:scroll={handle}
	clearable={clearable}
	on:change={handleOnchange}
	disabled={disabled}
>
	<div slot="item" class="mb-2.5 flex items-center gap-2.5" on:scroll={handle} let:item>
		<!-- Pass the item to parent component from slot -->
		<slot prop={item}></slot>
	</div>
</Select>
